import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const request = async (path, options = {}) => handleResponse(await fetch(`${config.api.url}/notifications${path}`, {
  ...options,
  headers: getAuthHeaders(),
}));
const orgQuery = (organizationId) => `organizationId=${encodeURIComponent(organizationId ?? 0)}`;

const notificationsApi = {
  getPreferences: (organizationId) => request(`/preferences?${orgQuery(organizationId)}`),
  savePreferences: (organizationId, preferences) => request(`/preferences?${orgQuery(organizationId)}`, {
    method: 'PUT', body: JSON.stringify(preferences),
  }),
  getDefaults: (organizationId) => request(`/defaults?${orgQuery(organizationId)}`),
  saveDefaults: (organizationId, preferences) => request(`/defaults?${orgQuery(organizationId)}`, {
    method: 'PUT', body: JSON.stringify(preferences),
  }),
  list: (organizationId, beforeId) => request(`?${orgQuery(organizationId)}&limit=50${beforeId ? `&beforeId=${encodeURIComponent(beforeId)}` : ''}`),
  markRead: (id, isRead = true) => request(`/${encodeURIComponent(id)}/read`, {
    method: 'PATCH', body: JSON.stringify({ isRead }),
  }),
  markAllRead: (organizationId) => request('/read-all', {
    method: 'POST', body: JSON.stringify({ organizationId: Number(organizationId ?? 0) }),
  }),
  resolveTarget: (id) => request(`/${encodeURIComponent(id)}/target`),
  test: (channel) => request('/test', { method: 'POST', body: JSON.stringify({ channel }) }),
};

export default notificationsApi;
